import React from 'react';
import AndieGenericToolRender from './AndieGenericToolRender';
import { useTranslation } from 'react-i18next';
import { ActionRenderAi } from '@/ai/types/action-render-ai';
import { SearchRounded } from '@mui/icons-material';

type ActionResponse = {
    id: string;
    name: string;
    description: string | null;
    widgets: { id: string; name: string }[];
};

export type AndieGetDashboardDetailsByIdProps = ActionRenderAi<ActionResponse>;

const AndieGetDashboardDetailsById = (props: AndieGetDashboardDetailsByIdProps) => {
    const { t } = useTranslation();
    return (
        <AndieGenericToolRender<ActionResponse>
            title={() => t('andie.tool.get-dashboard-details-by-id.title')}
            icon={<SearchRounded fontSize="small" />}
            loadingMessages={() => [t('andie.tool.get-dashboard-details-by-id.loading')]}
            completeMessage={({ result }) =>
                t('andie.tool.get-dashboard-details-by-id.complete', {
                    name: result ? result.name : '',
                })
            }
            {...props}
        />
    );
};

export default AndieGetDashboardDetailsById;
